import React from "react";
import styles from "./UIMessageLink.module.scss";
import AutoLinkText from "react-autolink-text2";
import noImg from "../images/NoImg.png";
import playImg from "../images/playImg.png";
import classNames from "classnames";
import {expDomain, expURL} from "../ChatConstants";
import {getUrlHttp} from "src/service/util.service";
import UIMessageMention from "./UIMessageMention";
import {useTranslation} from "react-i18next";

function handleOpenDivLink(url) {
  window.open(url, "_system");
  return;
}

function handleOpenLink(event) {
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  window.open(event.target.href, "_system");
  return;
}

const regexURL = new RegExp(expURL);
const regexDomain = new RegExp(expDomain);

function UIMessageLink(props) {
  const { t } = useTranslation();
  const { msgObj, onClickMention } = props;
  let textURL = "";
  let domain = "";
  try {
    if (props.text?.match(regexURL)) textURL = props.text?.match(regexURL)?.[0];
    if (props.text?.match(regexDomain))
      domain = props.text?.match(regexDomain)?.[0];
  } catch (e) {
    console.error("[Chat Error] message : ", e);
  }
  const isAnother = props.isAnother;
  return (
    <div
      className={
        props.graphDetail?.videos?.length > 0
          ? isAnother > 1
            ? styles.msgStyleVideo2
            : styles.msgStyleVideo1
          : ""
      }
    >
      <div className={isAnother > 1 ? styles.openGraph2 : styles.openGraph1}>
        {props.graphDetail?.videos?.length > 0 ? (
          <div className={styles.linkVideo}>
            {props.text.replace(expURL, "").length > 1 && (
              <div className={styles.headerVideo} target="_blank">
                {props.msgObj?.mentionProperty ? (
                  <UIMessageMention
                    msgObj={msgObj}
                    onClickMention={onClickMention}
                  />
                ) : (
                  <AutoLinkText
                    text={props.text}
                    linkProps={{
                      target: "_blank",
                      onClick: !props.isSelect ? handleOpenLink : null,
                    }}
                  />
                )}
              </div>
            )}
            <div
              className={styles.previewImg}
              onClick={
                props.isSelect
                  ? undefined
                  : () =>
                      handleOpenDivLink(
                        props.graphDetail?.url
                          ? props.graphDetail?.url
                          : textURL
                      )
              }
            >
              <div
                style={{
                  width: "100%",
                  height: "150px",
                  borderRadius: "10px 10px 0 0",
                  backgroundColor: "#b8b8b8",
                  backgroundPosition: "0",
                  backgroundImage: `url(${getUrlHttp(
                    props.graphDetail.images[0].url
                  )})`,
                  backgroundSize: "cover",
                }}
              ></div>
              <div className={styles.playImg}>
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    backgroundPosition: "0px center",
                    backgroundImage: `url(${playImg})`,
                    backgroundSize: "cover",
                    margin: "auto",
                  }}
                ></div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={classNames("chat-title", styles.linkHtml)}
            target="_blank"
          >
            {msgObj?.mentionProperty ? (
              <UIMessageMention
                msgObj={msgObj}
                onClickMention={onClickMention}
              />
            ) : (
              <AutoLinkText
                text={props.text}
                linkProps={{
                  target: "_blank",
                  onClick: !props.isSelect ? handleOpenLink : null,
                }}
              />
            )}
          </div>
        )}
        <div
          className={styles.detailHtml}
          onClick={
            props.isSelect
              ? undefined
              : () =>
                  handleOpenDivLink(
                    props.graphDetail?.url ? props.graphDetail?.url : textURL
                  )
          }
          style={{
            display: "flex",
            verticalAlign: "middle",
            alignItems: "center",
          }}
        >
          <div
            className={
              props.graphDetail?.videos
                ? isAnother > 1
                  ? styles.descLinkVideo2
                  : styles.descLinkVideo1
                : isAnother > 1
                ? styles.descLink2
                : styles.descLink1
            }
          >
            {props.graphDetail?.title ? (
              <p className={classNames("chat-title", styles.linkTitle)}>
                {props.graphDetail.title !== "html"
                  ? props.graphDetail.title
                  : props.graphDetail?.siteName}
              </p>
            ) : (
              <p className={classNames("chat-title", styles.linkTitle)}>
                {domain}
              </p>
            )}
            {props.graphDetail?.videos &&
              props.graphDetail?.description &&
              (props.graphDetail?.description !== " " ? (
                <p
                  className={classNames("chat-caption", styles.linkDescription)}
                  style={{ minHeight: "50px" }}
                >
                  {props.graphDetail.description?.substr?.(0, 64) + "..."}
                </p>
              ) : (
                <p className={classNames("chat-meta", styles.linkSiteName)}>
                  {t("Tab here to open link")}
                </p>
              ))}
            {!props.graphDetail?.videos && (
              <p className={classNames("chat-meta", styles.linkSiteName)}>
                {t("Tab here to open link")}
              </p>
            )}
          </div>
          {props.graphDetail?.images?.[0].url ? (
            !props.graphDetail?.videos && (
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "5%",
                  backgroundColor: "#b8b8b8",
                  backgroundPosition: "0",
                  backgroundImage: `url(${getUrlHttp(
                    props.graphDetail.images[0].url
                  )})`,
                  backgroundSize: "cover",
                }}
              ></div>
            )
          ) : (
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "5%",
                backgroundColor: "#b8b8b8",
                backgroundPosition: "0",
                backgroundImage: `url(${noImg})`,
                backgroundSize: "cover",
              }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(UIMessageLink);
